import { Link } from "react-router-dom";
import { contactDetails } from "@/mocks/products";

const specialties = [
  "Türdrücker-Stifte",
  "Wechsel-Schlossstifte",
  "PSW-Stifte",
  "Vierkant-Stifte",
  "Vierkant-Stifte abgesetzt",
];

function HeroSection() {
  return (
    <section className="relative w-full bg-foreground-950 text-background-50 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.14]"
        style={{
          backgroundImage:
            "linear-gradient(135deg, oklch(var(--primary-500)) 0%, transparent 45%), radial-gradient(circle at 85% 20%, oklch(var(--accent-500)) 0%, transparent 40%)",
        }}
        aria-hidden="true"
      />
      <div className="relative w-full px-4 md:px-8 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="animate-rise">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-foreground-900 border border-foreground-700 font-label text-[11px] uppercase tracking-[0.18em] text-accent-300">
            <i className="ri-award-line" aria-hidden="true" />
            Herzlich Willkommen
          </p>
          <h1 className="mt-6 font-heading font-semibold text-3xl md:text-5xl leading-[1.1] text-background-50">
            bei der Franz Drexelius Metallverarbeitung GmbH.
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-200">
            Wir sind die Spezialisten für Drückerverbindungen – gefertigt in Deutschland, seit 1956.
          </p>

          <ul className="mt-7 flex flex-wrap gap-2">
            {specialties.map((item) => (
              <li
                key={item}
                className="px-3.5 py-1.5 rounded-full bg-foreground-900 border border-foreground-700 font-label text-xs tracking-wide text-background-100"
              >
                {item}
              </li>
            ))}
          </ul>

          <p className="mt-7 max-w-xl text-sm md:text-base leading-relaxed text-background-200">
            Auf Anfrage fertigen wir für Sie Sonderausführungen an – Fertigungslose ab 300 Stück.
            Haben Sie Fragen zu diesen oder nicht abgebildeten Spezial-Drückerverbindungen?{" "}
            <span className="text-background-50 font-semibold">Rufen Sie uns an!</span>
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-600 text-background-50 font-label text-sm uppercase tracking-wide whitespace-nowrap hover:bg-primary-500 transition-colors"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true" />
              Anfrage senden
            </Link>
            <a
              href={contactDetails.phoneHref}
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-600 text-background-50 font-label text-sm uppercase tracking-wide whitespace-nowrap hover:bg-foreground-900 transition-colors"
            >
              <i className="ri-phone-line text-base" aria-hidden="true" />
              {contactDetails.phone}
            </a>
          </div>
        </div>

        <div className="relative animate-rise-slow">
          <div className="relative w-full rounded-lg overflow-hidden border border-foreground-700 aspect-[16/10]">
            <img
              src="https://www.franz-drexelius.de/wp-content/uploads/2010/12/Drexelius-Metallverarbeitung-2011-small.jpg.webp"
              alt="Werk der Franz Drexelius Metallverarbeitung GmbH in Finnentrop-Heggen"
              title="Franz Drexelius Metallverarbeitung – Spezialfabrik in Finnentrop-Heggen"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 left-6 md:left-10 flex items-center gap-3 px-4 py-3 rounded-md bg-accent-500 text-accent-950">
            <i className="ri-history-line text-xl" aria-hidden="true" />
            <span className="font-heading text-sm uppercase tracking-wide">
              Spezialfabrik <br className="hidden md:block" /> seit 1956
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;